export const countries = [
  { value: "USA", name: "United States of America" },
  { value: "CA", name: "Canada" },
];

export const provinces = {
  USA: [
    { value: "AK", name: "Alaska" },
    { value: "AL", name: "Alabama" },
    { value: "AR", name: "Arkansas" },
    { value: "AS", name: "American Samoa" },
    { value: "AZ", name: "Arizona" },
    { value: "CA", name: "California" },
    { value: "CO", name: "Colorado" },
    { value: "CT", name: "Connecticut" },
    { value: "DC", name: "District of Columbia" },
    { value: "DE", name: "Delaware" },
    { value: "FL", name: "Florida" },
    { value: "GA", name: "Georgia" },
    { value: "GU", name: "Guam" },
    { value: "HI", name: "Hawaii" },
    { value: "IA", name: "Iowa" },
    { value: "ID", name: "Idaho" },
    { value: "IL", name: "Illinois" },
    { value: "IN", name: "Indiana" },
    { value: "KS", name: "Kansas" },
    { value: "KY", name: "Kentucky" },
    { value: "LA", name: "Louisiana" },
    { value: "MA", name: "Massachusetts" },
    { value: "MD", name: "Maryland" },
    { value: "ME", name: "Maine" },
    { value: "MI", name: "Michigan" },
    { value: "MN", name: "Minnesota" },
    { value: "MO", name: "Missouri" },
    { value: "MS", name: "Mississippi" },
    { value: "MT", name: "Montana" },
    { value: "NC", name: "North Carolina" },
    { value: "ND", name: " North Dakota" },
    { value: "NE", name: "Nebraska" },
    { value: "NH", name: "New Hampshire" },
    { value: "NJ", name: "New Jersey" },
    { value: "NM", name: "New Mexico" },
    { value: "NV", name: "Nevada" },
    { value: "NY", name: "New York" },
    { value: "OH", name: "Ohio" },
    { value: "OK", name: "Oklahoma" },
    { value: "OR", name: "Oregon" },
    { value: "PA", name: "Pennsylvania" },
    { value: "PR", name: "Puerto Rico" },
    { value: "RI", name: "Rhode Island" },
    { value: "SC", name: "South Carolina" },
    { value: "SD", name: "South Dakota" },
    { value: "TN", name: "Tennessee" },
    { value: "TX", name: "Texas" },
    { value: "UT", name: "Utah" },
    { value: "VA", name: "Virginia" },
    { value: "VI", name: "Virgin Islands" },
    { value: "VT", name: "Vermont" },
    { value: "WA", name: "Washington" },
    { value: "WI", name: "Wisconsin" },
    { value: "WV", name: "West Virginia" },
    { value: "WY", name: "Wyoming" },
  ],
  CA: [
    { value: "AB", name: "Alberta" },
    { value: "BC", name: "British Columbia" },
    { value: "MB", name: "Manitoba" },
    { value: "NB", name: "New Brunswick" },
    { value: "NL", name: "Newfoundland and Labrador" },
    { value: "NT", name: "Northwest Territories" },
    { value: "NS", name: "Nova Scotia" },
    { value: "NU", name: "Nunavut" },
    { value: "ON", name: "Ontario" },
    { value: "PE", name: "Prince Edward Island" },
    { value: "QC", name: "Quebec" },
    { value: "SK", name: "Saskatchewan" },
    { value: "YT", name: "Yukon Territory" },
  ],
  NA: [{ value: "", name: "Please Select Country" }],
};
